export function initHeaderVideo() {
    document.querySelectorAll('[data-video-toggle]').forEach((button) => {
        const video = document.getElementById(button.dataset.videoToggle);
        const icon = button.querySelector('i.icon');

        if (!video) return;

        const syncState = () => {
            const isPlaying = !video.paused;

            button.setAttribute('aria-pressed', String(isPlaying));
            button.setAttribute('aria-label', isPlaying ? button.dataset.labelPause : button.dataset.labelPlay);
            icon?.classList.toggle('icon-pause', isPlaying);
            icon?.classList.toggle('icon-play', !isPlaying);
        };

        button.addEventListener('click', () => {
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        });

        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);

        syncState();
    });
}
